/**
 * Installed pre-parity clients saved an untouched Emergency Plan contacts box
 * as null. Only an explicit marker from the parity editor proves that null was
 * authored. Apply this on writes and reads during the old-client rollout.
 */
export function normaliseLegacyEpNull(input: unknown): unknown {
  if (input === null || typeof input !== "object" || Array.isArray(input)) return input;
  const draft = input as Record<string, unknown>;
  const versioned = "generationDraftVersion" in draft;
  const holder = versioned ? draft.answers : draft;
  if (holder === null || typeof holder !== "object" || Array.isArray(holder)) return input;
  const answers = holder as Record<string, unknown>;
  if (answers.emergencyContacts !== null ||
      (versioned && draft.emergencyContactsAuthoredEmpty === true)) return input;
  const { emergencyContacts: _legacy, ...retained } = answers;
  void _legacy;
  return versioned ? { ...draft, answers: retained } : retained;
}
